import { forwardRef, useId } from 'react';
import { cn } from '../../lib/utils';

interface SelectProps extends React.SelectHTMLAttributes<HTMLSelectElement> {
  label?: string;
  options: { value: string; label: string }[];
}

export const Select = forwardRef<HTMLSelectElement, SelectProps>(
  ({ className, label, options, id: externalId, ...props }, ref) => {
    const generatedId = useId();
    const selectId = externalId ?? generatedId;

    return (
      <div className="w-full">
        {label && <label htmlFor={selectId} className="block mb-1.5 text-xs font-medium text-ink-mid">{label}</label>}
        <select
          ref={ref}
          id={selectId}
          className={cn(
            'input-base appearance-none cursor-pointer',
            className,
          )}
          {...props}
        >
          {options.map(o => <option key={o.value} value={o.value}>{o.label}</option>)}
        </select>
      </div>
    );
  }
);
Select.displayName = 'Select';
